module.exports = __webpack_public_path__ + "media/site/images/case_studies/eplanning/planning2@2x-a423aaf08ac63d938ebc151dae7a9329.png";